import React from "react";
import ReactDom from "react-dom";
import AgentLogin from "./AgentLogin.jsx";

export function initAgentLogin() {
  const div = document.querySelector(".js-agent-login-form");
  if (div) {
    const redirect = div.getAttribute("data-redirect") || "";
    ReactDom.render(<AgentLogin redirect={redirect} />, div);
  }
}
